import { GATOR_PROTECT_ID } from '../GatorProtect.enum';

export type GatorProtectProductId =
  (typeof GATOR_PROTECT_ID)[keyof typeof GATOR_PROTECT_ID];

/**
 * Recurring price row from WHMCS checkout product (`data.products[].prices.pricing` / `renewalPricing`).
 * Cycle amounts are typically decimal strings; `-1.00` means unavailable for that cycle.
 */
export type CheckoutProductPricingCycleRow = {
  id?: number;
  type?: string;
  currency?: number;
  relid?: number;
  msetupfee?: string;
  qsetupfee?: string;
  ssetupfee?: string;
  asetupfee?: string;
  bsetupfee?: string;
  tsetupfee?: string;
  monthly?: string;
  quarterly?: string;
  semiannually?: string;
  annually?: string;
  biennially?: string;
  triennially?: string;
};

export type CheckoutProductCyclesDiscountEntry = {
  percentageCoupon?: number;
  percentageCycle?: number;
  baseTotal?: number;
};

/**
 * Single product as returned by `parseProduct` from `GET /api/v3/checkout/product/:id`
 * and appended to `state.products.consultedProducts`.
 */
export type ConsultedGatorProduct = {
  id: number;
  type?: string;
  currency?: number;
  name?: string;
  tax?: boolean;
  description?: string;
  groupName?: string;
  freedomain?: string;
  freedomainCycles?: string[];
  freedomainTlds?: string[];
  prices?: {
    pricing?: CheckoutProductPricingCycleRow;
    renewalPricing?: CheckoutProductPricingCycleRow;
  };
  configoptions?: unknown[];
  cycles?: string[];
  cyclesDiscount?: Record<string, CheckoutProductCyclesDiscountEntry>;
  related?: unknown[];
};

/**
 * Stable empty array returned when a consulted product is not in Redux yet (loading sentinel).
 */
export const EMPTY_GATOR_PROTECT_PRODUCT = [] as ConsultedGatorProduct[];
